import { LOCALE_CODE, LOCALES, NAVIGATION } from '@src/constants';
import {
  IGetSubdomainsState,
  ILocaleCode,
} from '@src/interfaces/locale.interfaces';
import { IGetCurrentPathnames } from '@src/interfaces/navigation.interfaces';

import { getCurrentLocaleOptionByRegion } from './locales.helpers';

export const checkForLocalhost = (host: string) => {
  const newHost = host?.split('.');
  return newHost.some((str) => str.includes('localhost'));
};

export const getCurrentHost = () => {
  const hostArray = window.location.host.split('.');

  const isLocalhost = checkForLocalhost(window.location.host);
  const checkLengthNumber = isLocalhost ? 2 : 3;

  return hostArray.length >= checkLengthNumber ? hostArray : ['', ...hostArray];
};

export const getCountryCodeBySubdomain = (): ILocaleCode => {
  const [subdomain] = getCurrentHost();
  let hostLocale: ILocaleCode = LOCALE_CODE.EN;

  if (checkIsCorrectSubdomain(subdomain)) {
    hostLocale = subdomain as ILocaleCode;
  }

  return hostLocale;
};

export const checkIsCorrectSubdomain = (subdomain: string) => {
  return !!Object.values(LOCALES).find(
    ({ region }) => region === subdomain.toUpperCase(),
  );
};

export const getLocaleCodeBySubdomain = (): ILocaleCode => {
  const [subdomain] = getCurrentHost();
  const option = getCurrentLocaleOptionByRegion(subdomain);
  return option.code;
};

export const getSubdomainsState = () => {
  const countryCode = getCountryCodeBySubdomain();

  return Object.values(LOCALES).reduce(
    (acc, { code, region }) => ({
      ...acc,
      [`is${code.toUpperCase()}`]:
        countryCode.toLowerCase() === region.toLowerCase(),
    }),
    {} as IGetSubdomainsState,
  );
};

export const getHostWithNewSubdomain = (newSubDomain: string) => {
  const [currentSubdomain, ...restHostProps] = getCurrentHost();
  let host = restHostProps;

  if (currentSubdomain === 'dev') host = getCurrentHost();

  if (
    newSubDomain !== LOCALE_CODE.EN &&
    checkIsCorrectSubdomain(newSubDomain)
  ) {
    host = [newSubDomain, ...host];
  }

  return host.join('.');
};

export const createLinkWithNewSubdomain = (region: string) => {
  const host = getHostWithNewSubdomain(region.toLowerCase());
  const isLocalhost = checkForLocalhost(host);

  const transferProtocol = isLocalhost ? 'http' : 'https';

  return `${transferProtocol}://${host}`;
};

export const clearSearchParamsByHistoryAPI = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
  // Preserve React Router's history index and location state for POP blocking.
  window.history.replaceState(
    window.history.state,
    document.title,
    window.location.pathname,
  );
};

export const getCurrentPathnames = (pathname: string): IGetCurrentPathnames =>
  Object.entries(NAVIGATION).reduce(
    (acc, [key, value]) => ({ ...acc, [`IS_${key}_PAGE`]: pathname === value }),
    {} as IGetCurrentPathnames,
  );
